import React, {
  useState,
  useRef,
  useEffect,
} from "react";
import { useNavigate } from "react-router-dom";
import { Button, Container, Dialog, Stack, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlay,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { AccordianGrid, AccordionSet } from "../Components/AccordianGrid.jsx";
import { CrumbToggleScenario } from "../Components/CrumbToggles.jsx";
import { API_Client, APIs_selectScenario } from "../App/api.jsx";
import {
  getOptions,
  postOptions,
  deleteOptions,
  ScenarioUrl,
  UrlOptions,
  empty_uuid,
  ftchPlus,
  FtchPlusError,
} from "../App/Account_urls.jsx";
import { CheckboxCompareRenderer, CopyIconRenderer, DeleteIconRenderer, ViewIconRenderer, WhoWhenRenderer, iconSize } from "../App/GridRenderers.jsx";

import { ErrorBar } from "../Components/ErrorBar.jsx";
import DialogDelete from "../Components/DialogDelete.jsx";
import { Help_selectScenario } from "../Dialogs/Help/Help_Select.jsx";
import { WhoWhenFormatter } from "../App/GridFormatters.jsx";
import ChartViewSelector, { ComparePort } from "../App/ChartViewSelector.jsx";
import { useAuth } from "../App/useAuth.jsx";
import AdminCopyScenario from "../Components/AdminCopyScenario.jsx";
import { ColumnHeaderIcon, GridCompareSelector, InputCompareSelector } from "./GridScenario.jsx";


const CopyOptions = ({ show,
  onClose,
  item = "",
  onCopy,
  onCopyToBase,
  onCancel = null }) => {

  const myCancel = () => {
    if (onCancel !== null) {
      onCancel()
    }
    onClose()
  }

  const myCopy = () => {
    onCopy()
    onClose()
  }
  const myCopyToBase = () => {
    onCopyToBase()
    onClose()
  }



  return (
    <>
      {show && (
        < Dialog
          sx={{
            overflow: "scroll",
            "& .MuiDialog-container": {
              display: "inline-flex !important",
              width: "100%",
            },
          }}

          width="60%"
          maxWidth="100%"
          open={show}
          onClose={onClose}
        >
          <Stack spacing={5}>
            <Typography sx={{ mx: 10, pt: 10, display: "flex", justifyContent: "center", }} id="delete" variant="h6" gutterBottom>
              Copy Options
            </Typography>
            <Stack sx={{ px: 10, mx: 10 }} direction="row" spacing={10}>

              <Button variant="contained" onClick={myCopy} style={{ display: "block", textAlign: "center", textTransform: 'capitalize' }}          >
                <Typography variant="b1" >Copy from</Typography>
                <Typography variant="h6">{item}</Typography>
                <Typography variant="b1" >To a new scenario </Typography>
              </Button>
              <Button variant="contained" onClick={myCopyToBase} style={{ display: "block", textAlign: "center", textTransform: 'capitalize' }}            >
                <Typography variant="b1" >Copy clients/accounts/rules from</Typography>
                <Typography variant="h6">{item}</Typography>
                <Typography variant="b1" >to the BASE client </Typography>
              </Button>
            </Stack>
            <Button variant="contained" color="secondary" onClick={myCancel}>
              Cancel
            </Button>
          </Stack>

        </Dialog >
      )}
    </>
  )
}
const ScenarioSelect = ({ clientJson, c_callback }) => {
  const navigate = useNavigate();
  const icon = useRef();
  const { admin_r } = useAuth();
  const [admin] = useState(admin_r.current)


  const clientData = useRef;
  const [clients, setClients] = useState([]);
  const [personal, setPersonal] = useState();
  const [personalSweep, setPersonalSweep] = useState();


  const [showCompare, setShowCompare] = useState(false);
  const [diaCopy, setDiaCopy] = useState(false);

  const [errmsg, setErrmsg] = useState("")
  const [diaDelete, setDiaDelete] = useState(false)
  const [refetch, setRefetch] = useState(0)
  const [compUuids, setCompUuids] = useState([])
  const [openAccordion, setOpenAccordion] = useState("0")



  // this is a big hack, but it works well

  const cellClickedListener = (accountType, e, gridRef) => {
    console.log(e);
    let json = clientJson;
    if (accountType === "Scenarios") {
      if (clientJson.Scenario.uuid !== e.data.Uuid) {
        console.log(e.data.Executed)
        let scen = {
          ...json.Scenario,
          uuid: e.data.Uuid,
          label: e.data.Label,
          readonly: e.data.Locked,
          executed: e.data.Executed.Who,
        };
        let sw = { ...json.Sweep, emp: empty_uuid, label: "" };
        json.Scenario = scen;
        json.Sweep = sw;


        // json.Scenario.uuid = e.data.Uuid
        // json.Scenario.label = e.data.Label
        // json.Scenario.readonly = e.data.Locked
        // json.Sweep.emp = empty_uuid
        // json.Sweep.label = ""
        c_callback(json);
      }
    } else if (accountType === "Sweeps") {
      let scen = {
        ...json.Scenario,
        uuid: empty_uuid,
        label: "",
        readonly: false,
        executed: "",
      };
      let sw = { ...json.Sweep, uuid: e.data.Uuid, label: e.data.Label };
      json.Scenario = scen;
      json.Sweep = sw;
      c_callback(json);
    }
    if (
      e.colDef.headerName === "View" ||
      e.colDef.headerName === "Delete" ||
      e.colDef.headerName === "Sweep" ||
      e.colDef.headerName === "Copy"
    ) {
      if (icon.current) {
        switch (icon.current) {
          case "go-view": {
            console.log("Scenario View");
            if (e.data.Type === "scenario") {
              navigate("/gridScenario");
            } else if (e.data.Type === "sweep") {
              navigate("/sweep");
            }
            break;
          }
          case "go-copy": {
            setDiaCopy(true)
            break;
          }
          case "go-delete": {
            setDiaDelete(true)

            //DoDelete();
            break;
          }
          case "go-to-incomerules": {
            navigate("/setupIncomeRules");

            break;
          }
          case "go-to-savingrules": {
            navigate("/setupSavingRules");

            break;
          }

          case "go-to-scenario-latest": {
            console.log("Delete scen latest clicked");
            break;
          }
          default: {

          }
        }
      }
    } else if (e.colDef.headerName === "Compare") {
      setShowCompare(false);
      if (e.data.Compare) {
        gridRef.current.api.forEachNode(function (rowNode) {
        });
      }
    }
    icon.current = "";
  };


  const okDelete = () => {
    DoDelete()
  }

  const okCopy = () => {
    DoClone()
  }
  const okCopyToBase = () => {
    DoCopyToBase()
  }
  // const cellClickedListenerPublic = (accountType, e) => {
  //   console.log(e);
  //   let c_uuid = e.data.Uuid;
  //   let c_name = e.data.FullName;
  //   let s_name = e.data.Spouse;
  //   console.log(e.data);
  //   setClients([c_name, s_name]);
  //   setClient(c_name);
  //   let c_json = {
  //     public: true,
  //     shared: false,
  //     uuid: c_uuid,
  //     name: c_name,
  //     Scenario: {
  //       uuid: empty_uuid,
  //     },
  //     Sweep: {
  //       uuid: empty_uuid,
  //     },
  //   };
  //   console.log(c_json);

  //   c_callback(c_json);
  //   setclient_(c_json);
  //   if (e.colDef.headerName === "View" || e.colDef.headerName === "Action") {
  //     switch (icon.current) {
  //       case "go-view": {
  //       }
  //       case "go-copy": {
  //         DoClone();
  //         break;
  //       }
  //     }
  //   }
  // };

  //  consuming Grid Event

  const doCompare = (xapi) => {
    setShowCompare(false);
    if (xapi === null) {
      return
    }


    let uuids = []
    xapi.forEachNode(function (rowNode) {
      let compareNo = rowNode.data.Compare !== undefined ? Number(rowNode.data.Compare) : 0
      if (compareNo !== 0) {
        let uuid = {
          number: compareNo,
          uuid: rowNode.data.Uuid,
          label: rowNode.data.Label
        }
        uuids.push(uuid)
      }
    })
    //console.log(uuids)
    if (uuids.length > 1) {
      uuids.sort((a, b) => ((a.number - b.number)))

      setCompUuids(uuids)
      setShowCompare(true);
      xapi.forEachNode(function (rowNode) {
        rowNode.setDataValue("Compare", 0);
      })

    }
  }


  const Compare = (props) => {
    return (
      <center>
        <ColumnHeaderIcon
          displayName={"Compare"}
          icon={faPlay}
          rotate={270}
          onClick={() => { doCompare(props.api) }}

        />

      </center>
    );
  };




  const FavIconRenderer = (props) => {
    return (
      <div>
        {props.value && (
          <FontAwesomeIcon
            icon={faStar}
            size={iconSize}
            color="gold"
            //className="App-icon"
            onClick={() => {
              icon.current = "go-fav";
            }}
          ></FontAwesomeIcon>
        )}
      </div>
    );
  };

  const cd_Label = {
    headerName: "Label",
    field: "Label",
    width: 400,
    sortable: true,
    cellStyle: { textAlign: "left" },
    filter: "agTextColumnFilter",
  };
  const cd_Comments = {
    headerName: "Comments",
    field: "Description",
    width: 300,
    cellStyle: { textAlign: "left" },
    filter: "agTextColumnFilter",
    sortable: true,
  };
  const cd_Parent = {
    headerName: "Parent",
    field: "ParentLabel",
    width: 200,
    cellStyle: { textAlign: "left" },
    filter: "agTextColumnFilter",
    sortable: true,
  };

  const cd_Runs = {
    headerName: "Runs",
    field: "Runs",
    type: "rightAligned",
  };

  const WhoWhenComparator = (valueA, valueB, nodeA, nodeB, isDescending) => {
    if (valueA.When) {
      if (valueB.When) {
        let d1 = new Date(valueA.When);
        let d2 = new Date(valueB.When);
        if (d1 < d2) {
          return -1;
        } else if (d1 === d2) {
          return 0;
        }
        return 1;
      }
      return -1;
    }
    return 1;
  };

  const cd_Modified = {
    headerName: "Modified",
    field: "Modified",
    cellRenderer: WhoWhenRenderer,
    valueFormatter: WhoWhenFormatter,

    // cellStyle: { textAlign: "center", lineHeight: "normal" },
    width: 200,
    sort: "desc",
    sortable: true,
    sortIndex: 1,
    comparator: WhoWhenComparator,
  };

  const cd_Executed = {
    headerName: "Executed",
    field: "Executed",
    cellRenderer: WhoWhenRenderer,
    valueFormatter: WhoWhenFormatter,

    // cellStyle: { textAlign: "center", lineHeight: "normal" },
    width: 200,
    //sort: "desc",
    comparator: WhoWhenComparator,
  };

  const cd_View = {
    headerName: "View",
    field: "Edit",
    cellRenderer: ViewIconRenderer,
    cellRendererParams: {
      callback: (e) => { icon.current = e },
      value: true,
    },
    width: 70,
  };
  const cd_Favourite = {
    headerName: "Fav",
    field: "Favourite",
    cellRenderer: FavIconRenderer,
    sortable: true,
    sort: "desc",
    sortIndex: 0,
    width: 95,
  };

  const cd_Compare = {
    headerName: "Compare",
    field: "Compare",
    width: 120,
    cellRenderer: CheckboxCompareRenderer,
    editable: true,
    headerComponent: Compare,
    // headerComponent: ScenarioComparisonHeader,
  };
  const cd_Sweep = {
    headerName: "Sweep",
    field: "Sweep",
  };

  const cd_Delete = {
    headerName: "Delete",
    field: "",
    cellRenderer: DeleteIconRenderer,
    cellRendererParams: {
      callback: (e) => { icon.current = e },
    },
    width: 70,


  };

  const cd_Copy = {
    headerName: "Copy",
    field: "",
    cellRenderer: CopyIconRenderer,
    cellRendererParams: {
      callback: (e) => { icon.current = e },
      value: true,
    },
    width: 70,
  };

  const cds_Personal = [
    cd_View,
    cd_Compare,
    cd_Favourite,
    cd_Label,
    cd_Comments,
    cd_Parent,
    cd_Runs,
    cd_Modified,
    cd_Executed,
    cd_Copy,
    cd_Delete,
  ];
  const cds_PersonalSweep = [
    cd_View,
    cd_Label,
    cd_Comments,
    cd_Parent,
    cd_Modified,
    cd_Executed,
    cd_Delete,
  ];
  const cds_Public = [cd_View, cd_Compare, cd_Sweep, cd_Label, cd_Comments, cd_Executed];

  const colDefs = () => {
    if (clientJson.readonly) {
      return cds_Public;
    }
    return cds_Personal;
  };
  const colDefsSweep = () => {
    if (clientJson.readonly) {
      return cds_Public;
    }
    return cds_PersonalSweep;
  };
  // const cds_Shared = [cd_View, cd_Label, cd_Executed, cd_Delete];

  const NonNullArray = (v) => {
    return v ? v : []
  }

  const Update = (cl) => {
    console.log("Set Client: " + cl);
    setPersonal(NonNullArray(clientData.current[cl].Personal));
    setPersonalSweep(NonNullArray(clientData.current[cl].PersonalSweep));

    // setShared(clientData.current[cl].Shared);
    // setPublicc(clientData.current[cl].Public);
  };

  const getData = async () => {
    console.log("getData scenario");
    console.log(clientJson);
    if (clientJson && clientJson.uuid) {
      var url = UrlOptions(
        clientJson,
        API_Client + clientJson.uuid + APIs_selectScenario,
        ""
      );
      ftchPlus(url, getOptions)
        .then((json) => {
          if (json) {
            console.log(json);
            clientData.current = json.ClientData;
            setClients(json.Clients);
            Update(json.Clients[0]);
          } else {
            console.log("no such data");
          }
        })
        .catch((error) => {
          console.log(error.message);
          setErrmsg(error.message)
          FtchPlusError(error)
        });
    }
  };

  const DoDelete = async () => {
    console.log("clone: " + clientJson.Scenario.uuid);
    var url = ScenarioUrl(clientJson, "", "");
    ftchPlus(url, deleteOptions)
      .then((json) => {
        console.log("did delete ");

        let cjson = clientJson;
        let scen = {
          ...cjson.Scenario,
          uuid: empty_uuid,
          label: "",
          readonly: false,
          executed: "",
        };
        let sw = { ...cjson.Sweep, uuid: empty_uuid, label: "" };
        cjson.Scenario = scen;
        cjson.Sweep = sw;
        c_callback(cjson);
        setRefetch(refetch + 1)
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
        FtchPlusError(error)
      });
  };

  const DoClone = async () => {
    console.log("clone: " + clientJson.Scenario.uuid);
    var url = ScenarioUrl(clientJson, "clone", "");
    ftchPlus(url, postOptions)
      .then((json) => {
        console.log("did clone ");
        setRefetch(refetch + 1)
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
        FtchPlusError(error)
      });
  };

  const DoCopyToBase = async () => {
    console.log("copyToBase: " + clientJson.Scenario.uuid);
    var url = ScenarioUrl(clientJson, "copybase", "");
    ftchPlus(url, postOptions)
      .then((json) => {
        console.log("did copy to base ");
        setRefetch(refetch + 1)
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
        FtchPlusError(error)
      });
  };

  // load data from sever
  // useEffect(() => {
  //   setErrmsg("")
  //   console.log("get init data")
  //   getData();
  // }, [clientJson.uuid]);

  useEffect(() => {
    setErrmsg("")
    console.log("Refetch data " + refetch)
    getData();
    // return () => {
    //   console.log("ScenarioSelect Unmounted")
    // }
  }, [refetch]);

  const getAccName = () => {
    let accName = "";
    if (clientJson.name) {
      accName = clientJson.name;
    }
    if (clientJson.spouseName) {
      accName += "/" + clientJson.spouseName;
    }
    //return accName;
    return ""
  };
  const myAccordionOpen = (key, state) => {
    if (state) {
      setOpenAccordion(key)
    } else {
      setOpenAccordion("")
    }
  }

  const My_AccordianGrid = ({ ...otherProps }) => {
    return (
      <AccordianGrid
        cellClickedListener={cellClickedListener}
        onClick_kb={myAccordionOpen}
        openKey={openAccordion}
        {...otherProps}
      />
    )
  }


  return (
    <div style={{ display: "flex" }}>
      <Container maxWidth="true">

        <Stack spacing={2}>
          <Stack direction="row" spacing={2}>
            <CrumbToggleScenario
              set={clients}
              //current={client}
              clientJson={clientJson}
              // onChange={onClientChange}
              onChange={() => { }}
              crumbClose={c_callback}
            />
          </Stack>

          <AccordionSet>
            <My_AccordianGrid
              eventKey="0"
              name={getAccName()}
              type="Scenarios"
              columnDef={colDefs()}
              data={personal}
              accountType="Scenarios"
            //add={true}
            />
            <My_AccordianGrid
              eventKey="1"
              name={getAccName()}
              type="Sweeps"
              columnDef={colDefsSweep()}
              data={personalSweep}
              accountType="Sweeps"
            //add={true}
            />
          </AccordionSet>
          {admin && (
            <AdminCopyScenario
              clientJson={clientJson}
              onError={(m) => { setErrmsg(m) }}
            />
          )
          }


        </Stack>
        {/* <ChartCompareInput
          clientJson={clientJson}
          show={showCompare}
          onClose={() => setShowCompare(false)}
          uuids={uuids}
        /> */}
        <ComparePort
          show={showCompare}
          onClose={() => setShowCompare(false)}
        >
          <Typography variant="h5" gutterBottom>
            Input
          </Typography>
          <InputCompareSelector
            clientJson={clientJson}
            show={showCompare}
            onClose={() => setShowCompare(false)}
            uuids={compUuids}
            onClick={() => { }}
          />
          <Typography variant="h5" gutterBottom>
            Grids
          </Typography>
          <GridCompareSelector
            clientJson={clientJson}
            show={showCompare}
            onClose={() => setShowCompare(false)}
            uuids={compUuids}
            onClick={() => { }}
          />
          <Typography variant="h5" gutterBottom>
            Charts
          </Typography>
          <ChartViewSelector
            clientJson={clientJson}
            show={showCompare}
            onClose={() => setShowCompare(false)}
            uuids={compUuids}


          />
        </ComparePort>
        <ErrorBar error={errmsg} />
        <Help_selectScenario />
      </Container>
      <DialogDelete
        show={diaDelete}
        onClose={() => setDiaDelete(false)}
        item={clientJson.Scenario.label}
        query="Do you wish to delete this scenario"
        onDelete={okDelete}
      />
      <CopyOptions
        show={diaCopy}
        onClose={() => setDiaCopy(false)}
        item={clientJson.Scenario.label}
        onCopy={okCopy}
        onCopyToBase={okCopyToBase}

      />
    </div>
  );
};

export default ScenarioSelect;
